import { Action, ActionType } from 'typesafe-actions';
import { ofType } from 'redux-observable';
import { Observable, of, OperatorFunction } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { toReduxError, GENERIC_FETCH_ERROR_MESSAGE } from '@universal/errors';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { fromApiRequest } from '@shared/apiClient/fromApiRequest';
import { CenterType } from '@appTypes/centerType';
import { CenterProductsType } from '@appTypes/centerProductsType';
import { Actions, actions } from '@redux/modules/centers';
import { TypedEpic } from './types';

const fetchCentersEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_CENTERS),
    withLatestFrom(state$) as unknown as OperatorFunction<Action<any>, ActionType<typeof actions.getCenters.request>[]>,
    switchMap(() =>
      fromApiRequest((signal) =>
        apiClient.get<CenterType[]>(ApiType.apimNafNoApi, {
          signal,
          url: ApiPaths[ApiType.apimNafNoApi].nafCenters,
        }),
      ).pipe(
        map((response) => actions.getCenters.success(response.data)),
        catchError((err) =>
          of(
            actions.getCenters.failure(
              toReduxError(
                err,
                'Oops, vi har problemer med motoren... Kunne ikke hente senterlisten! Ta kontakt med kundesenteret hvis problemet fortsetter!',
              ),
            ),
          ),
        ),
      ),
    ),
  );

const fetchCenterProductsEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_CENTER_PRODUCTS),
    withLatestFrom(state$) as unknown as OperatorFunction<
      Action<any>,
      ActionType<typeof actions.getCenterProducts.request>[]
    >,
    switchMap(([action]: { payload?: number }[]) => {
      const params = action.payload ? { centerId: action.payload } : undefined;

      return fromApiRequest((signal) =>
        apiClient.get<CenterProductsType[]>(ApiType.apimNafNoApi, {
          signal,
          url: ApiPaths[ApiType.apimNafNoApi].nafCentersProducts,
          params,
        }),
      ).pipe(
        map((response) => actions.getCenterProducts.success(response.data)),
        catchError((err) => of(actions.getCenterProducts.failure(toReduxError(err, GENERIC_FETCH_ERROR_MESSAGE)))),
      );
    }),
  );

export const epics: TypedEpic[] = [fetchCentersEpic, fetchCenterProductsEpic];
